"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var temp = function UpCircleTwoTone(primaryColor, secondaryColor) {
  return {
    name: 'up-circle',
    theme: 'twotone',
    nameWithTheme: 'up-circle-twotone',
    tag: 'svg',
    attrs: {
      xmlns: 'http://www.w3.org/2000/svg',
      class: 'icon',
      viewBox: '0 0 1024 1024'
    },
    children: [{
      tag: 'path',
      attrs: {
        fill: secondaryColor,
        d: 'M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm178 479h-46.9c-10.2 0-19.9-4.9-25.9-13.2L512 460.4 406.8 605.8c-6 8.3-15.6 13.2-25.9 13.2H334c-6.5 0-10.3-7.4-6.5-12.7l178-246c3.2-4.4 9.7-4.4 12.9 0l178 246c3.9 5.3.1 12.7-6.4 12.7z'
      },
      children: []
    }, {
      tag: 'path',
      attrs: {
        fill: primaryColor,
        d: 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z'
      },
      children: []
    }, {
      tag: 'path',
      attrs: {
        fill: primaryColor,
        d: 'M518.4 360.3c-3.2-4.4-9.7-4.4-12.9 0l-178 246c-3.8 5.3 0 12.7 6.5 12.7h46.9c10.3 0 19.9-4.9 25.9-13.2L512 460.4l105.2 145.4c6 8.3 15.7 13.2 25.9 13.2H690c6.5 0 10.3-7.4 6.4-12.7l-178-246z'
      },
      children: []
    }]
  };
};
temp.nameWithTheme = 'up-circle-twotone';
var UpCircleTwoTone = temp;
exports.default = UpCircleTwoTone;